<template>
  <div class="debug__container">
    <div class="debug__header">
      <h1 class="m-t-10">Debug</h1>
      <div class="debug___sub_container">
        <h2 class="m-b-10 m-t-10">Global Configuration</h2>
        <button @click="clearStorage">Reset State</button>
        <h2 class="m-b-10 m-t-10">Order Ahead Configuration</h2>
        <div class="debug__row m-t-5">
          <div class="debug__row__key">
            <h5>Order pickup:</h5>
          </div>
          <div class="debug__row__value">
            <input id="ptse" class="m-l-50" type="text" :value="selectedPickup" @change="changeOrderPickup" />
          </div>
        </div>
        <h2 class="m-b-10 m-t-10">Sentry adhoc error generator</h2>
        <div class="debug__row m-t-5">
          <div class="debug__row__key">
            <h5>Code:</h5>
          </div>
          <div class="debug__row__value">
            <input id="ptse" v-model="errorCode" type="text" />
          </div>
          <div class="debug__row__value">
            <button :disabled="errorCode === ''" class="m-l-10" @click="sendErrorToSentry">Send Error</button>
          </div>
        </div>
      </div>
      <div class="m-t-10 m-b-20">
        <select v-model="vendorName">
          <option disabled value="">Select a Vendor:</option>
          <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.name">
            {{ vendor.name }}
          </option>
        </select>
      </div>
    </div>
    <div v-if="selectedVendor.name" class="debug___sub_container">
      <h2>{{ selectedVendor.name }}</h2>
      <div class="debug__row m-b-10">
        <div class="debug__row__key">
          <h5>pickupTimeSelectionEnabled</h5>
        </div>
        <div class="debug__row__value">
          <input
            id="ptse"
            class="m-l-50"
            type="checkbox"
            :value="selectedVendor.pickupTimeSelectionEnabled"
            :checked="selectedVendor.pickupTimeSelectionEnabled"
            @change="onTogglePTS"
          />
        </div>
      </div>
      <div class="debug__row m-t-10">
        <div class="debug__row__key">
          <h5>Append Pickup Time</h5>
        </div>
        <div class="debug__row__value">
          <input v-model="samplePickupTime" type="text" class="w-100" placeholder="Time in ISO860" />
        </div>
      </div>
      <button class="m-b-10" @click="onAddPickupTime">Add Pickup Time</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { DateTime } from "luxon";
import errorLoggerAdapter from "../../adapters/errorLoggerAdapter";

export default {
  name: "Help",
  data() {
    return {
      vendorName: "",
      samplePickupTime: DateTime.now().plus({ hours: 4 }).toISODate(),
      errorCode: ""
    };
  },
  computed: {
    ...mapGetters({
      vendors: "vendor/getVendorsList",
      selectedPickup: "orderAhead/selectedPickup"
    }),
    selectedVendor() {
      return this.vendors.find(({ name }) => name === this.vendorName) || {};
    }
  },
  methods: {
    ...mapMutations({
      setVendorPickupTimeSelection: "vendor/setVendorPickupTimeSelectionEnabled",
      appendVendorPickupTime: "vendor/setVendorPickupTimeForDebug",
      setSelectedPickup: "orderAhead/setSelectedPickup"
    }),
    onTogglePTS() {
      const { id, pickupTimeSelectionEnabled: status } = this.selectedVendor;
      this.setVendorPickupTimeSelection({ id, status: !status });
    },
    onAddPickupTime() {
      if (!this.samplePickupTime.length) {
        alert("Please enter a time stamp in ISO8601 format");
      }
      const { id } = this.selectedVendor;
      this.appendVendorPickupTime({ id, time: this.samplePickupTime });
    },
    changeOrderPickup(event) {
      this.setSelectedPickup({ time: event.target.value });
    },
    clearStorage() {
      localStorage.clear();
      sessionStorage.clear();
      location.reload();
    },
    sendErrorToSentry() {
      errorLoggerAdapter.createIssue(this.errorCode, "Debugger", "TEST-ERROR", {
        description: "Test error produced from the debugger"
      });
      this.errorCode = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.debug {
  &__container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: rgb(67, 67, 67);
    color: whitesmoke;
    top: 28px;
    left: 0px;
  }
  &___sub_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  &__header {
    text-align: center;
  }
  &__row {
    width: 100%;
    display: flex;
    max-width: 400px;
    padding: 0px 20px;
    align-items: center;
    &__key {
      width: 40%;
      padding: 0px 20px;
    }
    &__value {
      width: 60%;
    }
  }
}
.w-100 {
  width: 100%;
}
</style>
